/**************************************************
 * Nombre:       TarjetaLidres
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const TarjetaLidres = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{pb: 6, pt: 6}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 400, textAlign: 'center', fontSize: 18, height: 90}}>
                    {item.descripcion}
                </Typography>
            </Grid>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 4}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'center',}}>
                    <Avatar src={item.img} sx={{width: 80, height: 80}}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                    <Typography sx={{fontWeight: 600, textAlign: 'center', fontSize: 20}}>{item.nombre}</Typography>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default TarjetaLidres